import psl_ui from '../../libs/psl_ui.js';
import template from './template.pst';

import state from '../../state.js';

import './style.scss';

psl_ui.templates.add('page_intro',template);

const {el,rpoints}=psl_ui.templates.render('page_intro');

let _clb;

rpoints.button.addEventListener('click',()=>{
	_ext.hide();
	if(_clb) _clb();
});

window.addEventListener('resize',()=>{
	if(!el.parentNode) return;
	_resize();
});

function _resize(){
	let width=window.innerWidth;
	let height=window.innerHeight;
	let coef = 1;

	if(width>height){
		width=width/1920;
		height=height/1080;
	} else {
		width=width/1080;
		height=height/1920;
	}

	coef = Math.min(width,height);

	rpoints.window.style.transform=`scale3d(${coef},${coef},1)`;
}

const _ext={
	show:({
		header,
		desc,
		clb,
		parent,
		cls = ''
	})=>{
		el.className=`page intro car_${state.car} ${cls}`;
		rpoints.header.innerHTML=header;
		rpoints.desc.innerHTML=`<p>${desc.join('</p><p>')}</p>`;
		_clb=clb;
		parent.insertBefore(el,parent.firstChild);
		_resize();
		rpoints.header.focus();
	},
	hide:()=>{
		if(el.parentNode) el.parentNode.removeChild(el);
	}
}

export default _ext;
